import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4fa6702e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "submitButton_part" }

import { ref } from "vue";
import AppFieldEditor from "@/components/AppFieldEditor.vue";
import { post } from '@/api/interactiveApi'
import { Toast as toast, Dialog as dialog } from 'vant';
import { useRouter } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  __name: 'Interactive',
  setup(__props) {

const router = useRouter();


const formData = ref({
    title: "",
    content: "",
});

async function onSubmit() {
    const id = await post(formData.value);
    if (!id) {
        toast.fail("保存失败");
        return;
    }
    dialog({ message: "保存成功" })
    router.push('/mulin');
}


return (_ctx: any,_cache: any) => {
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_form = _resolveComponent("van-form")!

  return (_openBlock(), _createBlock(_component_van_form, { onSubmit: onSubmit }, {
    default: _withCtx(() => [
      _createVNode(_component_van_field, {
        modelValue: formData.value.title,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.title) = $event)),
        name: "帖子主题",
        label: "帖子主题",
        "input-align": "right",
        placeholder: "请输入帖子标题主题，建议5~30个字",
        rules: [{ required: true, message: '请填写帖子主题' }]
      }, null, 8, ["modelValue"]),
      _createVNode(AppFieldEditor, {
        label: "帖子内容",
        modelValue: formData.value.content,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.content) = $event))
      }, null, 8, ["modelValue"]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_van_button, {
          block: "",
          class: "submitButton d-theme-btn",
          type: "primary",
          "native-type": "submit"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 提交帖子 ")
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})